import { fetchOrdersQueue } from './api';

const initialState = () => ({
  ordersQueueCount: null, // null = not loaded yet
});

export default {
  state: initialState,
  mutations: {
    SET_ORDERS_QUEUE(state, count) {
      state.ordersQueueCount = count;
    },
  },
  actions: {
    async fetchOrdersQueue({ commit, getters, rootState: { session } }) {
      if (!getters.functionalityDisplayOrdersQueueEnabled) {
        return;
      }
      try {
        const count = await fetchOrdersQueue({ session });
        commit('SET_ORDERS_QUEUE', count);
      } catch (error) {
        console.error(error);
      }
    },
  },
  getters: {
    ordersQueueCount: state => state.ordersQueueCount,
    shouldDisplayOrdersQueue: (state, getters) =>
      getters.functionalityDisplayOrdersQueueEnabled &&
      state.ordersQueueCount !== null &&
      state.ordersQueueCount > 0,
  },
};
